export default __webpack_public_path__ + "static/media/format_icon_gif.519b96eb.svg";